module.exports = __webpack_public_path__ + "static/media/noJobs.2bbcd02c.svg";